module.exports = __webpack_public_path__ + "static/media/fa_IR.js.a17ff19a.file";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/tinyMCELocale/fa_IR.js.file
// module id = 399
// module chunks = 81